import { useAppInitialization } from "../../hooks/useAppInitialization";
import { getRetailerRouteAccess } from "../../routing/getRetailerRouteAccess";
import { type ReactNode, useMemo, useState } from "react";
import {
  AppChromeContext,
  type AppChromeMode,
} from "./AppChromeContextDefinition";

export const AppChromeProvider = ({ children }: { children: ReactNode }) => {
  const [mode, setMode] = useState<AppChromeMode>("operational");
  const initialization = useAppInitialization();
  const { state, route } = initialization;
  let effectiveMode = mode;

  if (
    state.status === "initialization-error" ||
    state.status === "retrying-initialization"
  ) {
    effectiveMode = "focused";
  } else if (route.kind === "retailer-application") {
    // Keep legacy navigation out of Home while its session and access resolve.
    effectiveMode =
      getRetailerRouteAccess(initialization) === "allowed"
        ? "retailer"
        : "focused";
  }
  const value = useMemo(
    () => ({ mode: effectiveMode, setMode }),
    [effectiveMode],
  );

  return (
    <AppChromeContext.Provider value={value}>
      {children}
    </AppChromeContext.Provider>
  );
};
